import { GridColDef } from '@mui/x-data-grid';
import { Button, Chip, CircularProgress } from '@mui/material';
import dayjs from 'dayjs';
import { IFastMovingSkuVersionSummary } from '../../../types/api/response/fastmovingskuresponse';

export const getFastMovingSkuVersionsColumns = (
  handleActivate: (listVersion: number) => void,
  activatingVersion: number | null,
): GridColDef[] => [
  { field: 'list_version', headerName: 'Version', width: 90 },
  { field: 'filename', headerName: 'Filename', flex: 1, minWidth: 180 },
  { field: 'uploaded_by', headerName: 'Uploaded By', width: 140 },
  {
    field: 'uploaded_at',
    headerName: 'Uploaded At',
    width: 160,
    valueFormatter: (value: string) => (value ? dayjs(value).format('YYYY-MM-DD HH:mm') : ''),
  },
  { field: 'row_count', headerName: 'Rows', width: 90 },
  { field: 'matched', headerName: 'Matched', width: 90 },
  { field: 'unmatched', headerName: 'Unmatched', width: 100 },
  {
    field: 'is_active',
    headerName: 'Status',
    width: 110,
    renderCell: (params) => (
      <Chip
        size="small"
        label={params.value ? 'Active' : 'Not active'}
        color={params.value ? 'success' : 'default'}
      />
    ),
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 160,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const row = params.row as IFastMovingSkuVersionSummary;
      if (row.is_active) return null;
      const isActivating = activatingVersion === row.list_version;
      return (
        <Button
          variant="outlined"
          size="small"
          disabled={activatingVersion !== null}
          onClick={() => handleActivate(row.list_version)}
        >
          {isActivating ? <CircularProgress size={16} /> : 'Activate'}
        </Button>
      );
    },
  },
];
